// Referans Kod Sistemi Type Definitions

export enum CodeType {
  SINGLE_USE_BY_COMPANY = 'SINGLE_USE_BY_COMPANY',
  MULTI_USE_GENERAL = 'MULTI_USE_GENERAL'
}

export enum RewardType {
  PERCENTAGE_DISCOUNT = 'PERCENTAGE_DISCOUNT',
  FIXED_AMOUNT_DISCOUNT = 'FIXED_AMOUNT_DISCOUNT',
  FREE_SUBSCRIPTION_DAYS = 'FREE_SUBSCRIPTION_DAYS'
}

export enum RewardStatus {
  EARNED = 'EARNED',
  USED = 'USED',
  CANCELLED = 'CANCELLED'
}

export enum CodeStatus {
  ACTIVE = 'ACTIVE',
  USED = 'USED',
  EXPIRED = 'EXPIRED'
}

export interface ReferralCampaign {
  id: string;
  name: string;
  description?: string;
  isActive: boolean;
  codeType: CodeType;
  generalCode?: string; // MULTI_USE_GENERAL için
  usageLimit?: number; // MULTI_USE_GENERAL için
  newCompanyRewardType: RewardType;
  newCompanyRewardValue: number;
  referringCompanyRewardType: RewardType;
  referringCompanyRewardValue: number;
  expiresAt?: string; // ISO 8601 format
  createdAt: string;
  updatedAt: string;
}

export interface ReferralCode {
  id: string;
  code: string;
  campaignId: string;
  companyId: string;
  status: CodeStatus;
  createdAt: string;
  updatedAt: string;
  campaign?: ReferralCampaign;
}

export interface ReferralReward {
  id: string;
  rewardType: RewardType;
  rewardValue: number;
  status: RewardStatus;
  createdAt: string;
  sourceReferralCode: {
    code: string;
    usedByCompany?: {
      id: number;
      name: string;
    };
  };
}

// Eski ReferralHistory interface'i (v1.0 - deprecated)
export interface ReferralHistory {
  code: string;
  createdAt: string;
  campaignName: string;
  status: CodeStatus;
  referredCompany?: {
    id: number;
    name: string;
  } | null;
  reward?: {
    type: RewardType;
    value: number;
    status: RewardStatus;
  } | null;
}

// Yeni ReferralHistory interface'i (v2.0 - şirkete özel, çok kullanımlı kodlar)
export interface ReferralHistoryV2 {
  code: string;
  createdAt: string;
  campaignName: string;
  timesUsed: number; // Bu kodun toplam kaç kez kullanıldığı
  referredCompanies: Array<{
    id: number;
    name: string;
  }>; // Bu kodu kullanarak sisteme kaydolmuş tüm şirketlerin listesi
  earnedRewards: Array<{
    type: RewardType;
    value: number;
    status: RewardStatus;
    earnedFrom: {
      id: number;
      name: string;
    }; // Bu ödülün, hangi şirketin başarılı ödemesiyle kazanıldığını gösterir
  }>; // Bu kod sayesinde kazanılmış tüm ödüllerin listesi
}

export interface CampaignStats {
  campaignId: string;
  campaignName: string;
  isActive: boolean;
  totalGenerated: number;
  totalUsed: number;
  conversionRate: number;
}

export interface CreateReferralCodeRequest {
  campaignId: string;
}

export interface CreateCampaignRequest {
  name: string;
  description?: string;
  isActive: boolean;
  codeType: CodeType;
  generalCode?: string;
  usageLimit?: number;
  newCompanyRewardType: RewardType;
  newCompanyRewardValue: number;
  referringCompanyRewardType: RewardType;
  referringCompanyRewardValue: number;
  expiresAt?: string;
}

export interface UpdateCampaignRequest extends Partial<CreateCampaignRequest> {
  id: string;
}

// Referans kodu ödül bilgisi (yeni şirket kayıt formu için)
export interface ReferralRewardInfo {
  rewardType: RewardType;
  rewardValue: number;
  description: string;
}

